import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  ViewEncapsulation,
  WritableSignal,
  inject,
  signal
} from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from '~core/services/layout/layout.service';
import { FacilityState } from '~core/states/facility/facility.state';
import { SidebarState } from '~core/states/sidebar/sidebar.state';

import { AppState } from '../../states/app/app.state';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export type DashboardRoute = '/' | '/dashboards' | '/announcements';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: [ './sidebar.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit {

  private destroyRef = inject(DestroyRef);

  @Input() isMobile = false;

  @Input() visibility = 'show';

  @HostBinding('class.mobile') get mobileClass(): boolean {
    return this.isMobile;
  }

  @HostListener('window:click', [ '$event' ]) onClick(event: PointerEvent): void {
    const clickPosition = event.clientX;

    if (this.isMobile && clickPosition > 250) {
      this.state.set('collapsed', true);
    }
  }

  collapsed$ = this.state.collapsed$;
  dashboardRoute: DashboardRoute = '/dashboards';
  menuItems = [];
  navGroups$ = this.state.navLinks$;
  openGroupID:  WritableSignal<number> = signal(null);
  isMobileLayout = false;

  get facilityId(): number {
    return this.appState.get('facilityId');
  }

  constructor(
    private appState: AppState,
    private state: SidebarState,
    private layoutService: LayoutService,
    private facilityState: FacilityState,
    private router: Router
  ) {}

  ngOnInit() {

    let canCustomDashboard = this.facilityState.get('moduleSettings')?.CustomDashboards;
    this.dashboardRoute = canCustomDashboard ? '/dashboards' : '/announcements';

    this.state.dashboardRouted$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();

    this.layoutService.isMobile$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((isMobile: boolean) => {
      this.isMobileLayout = isMobile;
    });
  }

  setOpenGroup(groupID: number): void {
    this.openGroupID.update(openGroupID => groupID === openGroupID ? null : groupID);
  }


  isActive({ permitGroupID }): boolean {
    const isPermitLink = this.state.get('activePermitGroup');
    if (isPermitLink) {
      return this.state.get('activePermitGroup') === permitGroupID;
    }
  }

  dashboardsActive(route: any): boolean {
    return this.router.url.includes(route);
  }

}
